
import { mapActions, mapGetters, mapMutations } from 'vuex';
import CompareIcon from '@/components/svg/CompareIcon.vue';
import FavoritesClearIcon from '@/components/svg/FavoritesClearIcon.vue';
import CartIcon from '@/components/svg/CartIcon.vue';
import ProfileFilledIcon from '@/components/svg/ProfileFilledIcon.vue';
import ProfileEmptyIcon from '@/components/svg/ProfileEmptyIcon.vue';
import Header from '@/mixins/header';
import LanguageSwitch from '@/components/header/LanguageSwitch.vue';
import SearchFormCasa from '@/components/header/SearchFormCasa.vue';
import HeaderNavigationMixin from '~/mixins/HeaderNavigationMixin';

export default {
    name: 'HeaderCategory',
    mixins: [Header, HeaderNavigationMixin],
    components: {
        SearchFormCasa,
        LanguageSwitch,
        ProfileEmptyIcon,
        ProfileFilledIcon,
        CartIcon,
        FavoritesClearIcon,
        CompareIcon,
    },
    data() {
        return {
            isScrolled: false,
            isShowCategory: null,
            activeCategory: null,
            categories: [],
        };
    },
    computed: {
        ...mapGetters({
            globalSettings: 'global/globalSettings',
            getCurrentTheme: 'global/getCurrentTheme',
            compareProductsLength: 'compare/getCompareProductsLength',
            favoritesProductsLength: 'favorites/getProductsLength',
            cartProductsLength: 'cart/getProductsLength',
            getHeaderStyle: 'global/getHeaderStyle',
            getModalShow: 'search/getModalShow',
        }),
    },
    watch: {
        '$route.path': {
            handler() {
                this.closeCategoryMenu();
            },
        },
        '$i18n.locale': {
            handler() {
                this.closeCategoryMenu();
                this.$fetch();
            },
        },
    },
    methods: {
        ...mapActions('cart', ['openCart']),
        ...mapMutations('search', ['setModalShow']),
        ...mapMutations(['setShowNavigationMobile']),
        handleScroll() {
            this.isScrolled = window.scrollY > 0;
        },
        showCategory(categoryId, idx) {
            console.log(categoryId, 'categoryId');
            this.isShowCategory = {
                id: categoryId,
                idx: idx,
            };
            this.activeCategory = categoryId;
        },
        closeCategoryMenu() {
            console.log('213');
            this.isShowCategory = null;
            this.activeCategory = null;
        },
        isActiveCategory(categoryId) {
            return this.isShowCategory?.id === categoryId;
        },
        goToCategory(category) {
            this.$router.push(this.localePath({ path: `/${category.categoryUrl}` }));
        },
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    async fetch() {
        let menu = await this.$axios.$get('general/menu_tree');
        this.categories = menu;
    },
};
